import React from 'react';
import { useTranslation } from 'react-i18next';
import './About.css';
import workshopImage from './images/Nastroje.webp';
import hallImage from './images/Kovojoch.webp';
import { ImageReveal, Reveal, SplitText } from './motion';
import { COMPANY } from '../data/site';

const About = () => {
  const { t } = useTranslation();
  const vars = { founded: COMPANY.founded, hallYear: COMPANY.hallYear, employees: COMPANY.employees };

  return (
    <section id="about" className="section section--light about">
      <div className="container">
        <div className="about__grid">
          <div className="about__text">
            <SplitText text={t('about.title')} className="about__title" />
            <Reveal className="about__body" delay={0.1}>
              <p className="about__lead">{t('about.p1', vars)}</p>
              <p>{t('about.p2', vars)}</p>
              <p>{t('about.p3')}</p>
            </Reveal>
          </div>

          <div className="about__visual">
            <ImageReveal src={workshopImage} alt={t('about.imageAlt')} className="about__image" parallax={4} />
            <Reveal className="about__hall" delay={0.3} y={60}>
              <img src={hallImage} alt={t('about.hallAlt')} loading="lazy" />
              <span>{t('about.hallCaption')}</span>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
